import { render, staticRenderFns } from "./globalTourism.vue?vue&type=template&id=7478f485&scoped=true"
import script from "./globalTourism.vue?vue&type=script&lang=js"
export * from "./globalTourism.vue?vue&type=script&lang=js"
import style0 from "./globalTourism.vue?vue&type=style&index=0&id=7478f485&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478f485",
  null
  
)

export default component.exports